/**
 * @generated SignedSource<<756882cf45a8582319cb79bc7cb9ad69>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskExecutionFooterTodosComponent_TaskExecution$data = {
  readonly id: string;
  readonly todos: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionTodoIssue_todo">;
  }>;
  readonly " $fragmentType": "TaskExecutionFooterTodosComponent_TaskExecution";
};
export type TaskExecutionFooterTodosComponent_TaskExecution$key = {
  readonly " $data"?: TaskExecutionFooterTodosComponent_TaskExecution$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskExecutionFooterTodosComponent_TaskExecution">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskExecutionFooterTodosComponent_TaskExecution",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Todo",
      "kind": "LinkedField",
      "name": "todos",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RoutineOccasionTodoIssue_todo"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TaskExecution",
  "abstractKey": "__isTaskExecution"
};
})();

(node as any).hash = "675c714f17d582d369c28acab763d7f9";

export default node;
